import type React from 'react';

import type { UserFederationFailureDto } from 'api/generated/schemas';

import { Box } from 'ui/box';

interface TransitionResultStepProps {
  total: number;
  succeeded: number;
  failures: UserFederationFailureDto[];
  toTransitionLabel: string;
}

const TransitionResultStep = ({
  total,
  succeeded,
  failures,
  toTransitionLabel,
}: TransitionResultStepProps): React.JSX.Element => (
  <Box sx={{ mt: 0.5 }}>
    <p className="text-sm text-gray-500 mb-3">
      {`Demo, internal, test users, and users already on ${toTransitionLabel} are excluded from the transition.`}
    </p>
    <p>{`Attempted: ${total}`}</p>
    <p>{`Transitioned: ${succeeded}`}</p>
    {!!failures.length && (
      <>
        <p className="mb-4">{`Failed: ${failures.length}`}</p>
        <h2 className="font-bold text-xl">Errors:</h2>
        <ul className="max-h-80 min-h-0 overflow-y-auto mt-2 space-y-3 text-sm text-gray-600">
          {failures.map((failure) => (
            <li key={`${failure.userId ?? failure.email}`}>
              <p className="font-bold text-base">{failure.email}</p>
              <code>{failure.errorMessage}</code>
            </li>
          ))}
        </ul>
      </>
    )}
  </Box>
);

export default TransitionResultStep;
